import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "@shared/index.css";
import { ThemeProvider } from "@shared/theme";
import { NotificationProvider } from "@shared/components/NotificationProvider";
import GlobalApiErrorBoundary from "@shared/components/GlobalApiErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ThemeProvider>
      <NotificationProvider>
        <GlobalApiErrorBoundary />
        <App />
      </NotificationProvider>
    </ThemeProvider>
  </BrowserRouter>
);
